export default function (context) {
  // export default function({ $axios, redirect }) {
  context.$axios.onRequest((config) => {
    const today = new Date()
    const time =
      today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds()
    config.baseURL = process.env.BASE_URL

    if (config.url.includes('/CACHE_URL/')) {
      config.url = config.url.replace('/CACHE_URL/', '')
      config.baseURL = process.env.CACHE_URL
    }

    if (config.url.includes('/GRAPHQL_URL/')) {
      config.url = config.url.replace('/GRAPHQL_URL/', '')
      config.baseURL = process.env.GRAPHQL_URL
    }

    if (config.url.includes('/BASE_URL/')) {
      config.url = config.url.replace('/BASE_URL/', '')
      config.baseURL = process.env.BASE_URL
    }

    if (config.url.includes('/RELIEF_URL/')) {
      config.url = config.url.replace('/RELIEF_URL/', '')
      config.baseURL = process.env.RELIEF_URL
    }

    if (config.url.includes('/INVITE_TOKEN_URL/')) {
      config.url = config.url.replace('/INVITE_TOKEN_URL/', '')
      config.baseURL = process.env.INVITE_TOKEN_URL
    }

    if (config.url.includes('/PROFILE_URL/')) {
      config.url = config.url.replace('/PROFILE_URL/', '')
      config.baseURL = process.env.PROFILE_URL
    }

    if (config.url.includes('/AUTH_URL/')) {
      config.url = config.url.replace('/AUTH_URL/', '')
      config.baseURL = process.env.AUTH_URL
    }

    if (config.url.includes('/SURVEY_URL/')) {
      config.url = config.url.replace('/SURVEY_URL/', '')
      config.baseURL = process.env.SURVEY_URL
    }

    if (config.url.includes('/GEO_CODING/')) {
      config.url = config.url.replace('/GEO_CODING/', '')
      config.baseURL = process.env.GEO_CODING
    }

    if (config.url.includes('/CORE_URL/')) {
      config.url = config.url.replace('/CORE_URL/', '')
      config.baseURL = process.env.CORE_URL
    }

    console.log(time + ': Making request to ' + config.url)
  })

  context.$axios.onError((error) => {
    console.log('----------- AXIOS ERROR -----------')
    // console.log(error)
    console.log(JSON.stringify(error, undefined, 2))
  })
}
